import moment from 'moment';
import React from 'react';
import { descriptionDateFormat } from '../settings';
import LoadingIndicator from '../../components/shared/LoadingIndicator/LoadingIndicator';
import { Card, Empty } from 'antd';
import ArchivedReportOverviewsTable from './ArchivedReportOverviewsTable';
import { useFetchOverviewsQuery } from '../service';
import { getOverviewApiStartDate, getOverviewApiEndDate } from '../utils';

type Props = {
    websiteUrl: string;
    startDate: moment.Moment;
    endDate: moment.Moment;
};

export default function ArchivedReportOverviewsCard({ websiteUrl, startDate, endDate }: Props) {
    const { data: overviews, isFetching: isFetchingOverviews } = useFetchOverviewsQuery({
        url: websiteUrl,
        startDate: getOverviewApiStartDate(startDate),
        endDate: getOverviewApiEndDate(endDate),
    });

    const hasOverviews = !isFetchingOverviews && !!overviews && overviews.length > 0;
    const hasNoOverviews = !isFetchingOverviews && overviews?.length === 0;

    return (
        <div className="archived-reports-box">
            <Card
                style={{ minHeight: '520px' }}
                title={
                    <div className="ant-card-meta-detail">
                        <div className="ant-card-meta-title">Archived reports</div>
                        <div className="ant-card-meta-description">{moment(startDate).startOf('month').format(descriptionDateFormat)}</div>
                    </div>
                }
            >
                {isFetchingOverviews && <LoadingIndicator />}
                {hasOverviews && (
                    <ArchivedReportOverviewsTable
                        overviews={overviews}
                        websiteUrl={websiteUrl}
                    />
                )}
                {hasNoOverviews && (
                    <Empty
                        className="empty-state"
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="There are no reports for the selected interval."
                    />
                )}
            </Card>
        </div>
    );
}
